export const CONTACT_INFO = {
  phone: '06 14886808',
  phoneHref: 'tel:0614886808',
  email: 'info@glutenvrijadvies.nl',
  emailHref: 'mailto:info@glutenvrijadvies.nl',
  instagram: 'https://www.instagram.com/glutenvrijadvies/',
} as const
